import React from 'react';
import '../styles/Testimonials.css';
import pic01 from '../assets/StockImages/pic01.jpg';
import pic02 from '../assets/StockImages/pic02.jpg';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Homeowner",
      image: pic01,
      text: "Absolutely amazing service! My house has never been cleaner. The attention to detail is impressive, and the team is always professional and friendly."
    },
    {
      id: 2,
      name: "Michael Brown",
      role: "Business Owner",
      image: pic02,
      text: "We've been using Bubble & Maple for our office cleaning needs for over a year now. Their consistency and quality of service is outstanding. Highly recommended!"
    }
  ];

  return (
    <section className="testimonials">
      <h2 className="testimonials-title">What Our Clients Say</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            <div className="testimonial-content">
              <p className="testimonial-text">{testimonial.text}</p>
            </div>
            <div className="testimonial-author">
              <img 
                src={testimonial.image} 
                alt={testimonial.name} 
                className="author-image"
              />
              <div className="author-info">
                <h3 className="author-name">{testimonial.name}</h3>
                <p className="author-role">{testimonial.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials; 